<template>
    <ValidationProvider v-slot="{ errors }" name="File" rules="image">
        <div class="MediaSelector__uploader" v-if="namespace">
            <div class="MediaSelector__uploader__input">
                <v-file-input outlined
                              label="Select File"
                              @change="selectFile"
                              dense
                              :error-messages="errors"
                              required
                              v-model="currentFile"
                              :id="'upload-' + namespace"
                              :name="'upload-' + namespace"
                              hide-input
                ></v-file-input>
            </div>
            <label class="MediaSelector__uploader__label" :class="{jsHasError:uploadErrors.length > 0}" :for="'upload-' + namespace">
                <transition name="fade">
                    <span v-if="uploadErrors.length > 0" class="FileLabel FileErrors">
                        <span class="icon" aria-hidden="true">
                            <v-icon color="white" x-large>fas fa-exclamation-triangle</v-icon>
                        </span>
                        <span class="text">
                            <span v-for="(error, index) in uploadErrors" :key="index" class="Error">
                                {{error}}
                            </span>
                        </span>
                    </span>
                    <span v-else class="FileLabel FileInstruction">
                        <span class="icon" aria-hidden="true">
                            <v-icon v-if="uploadType === 'image'" x-large>fas fa-image</v-icon>
                            <v-icon v-else x-large>fas fa-file-pdf</v-icon>
                        </span>
                        <span class="text">
                            Click Here to Upload A New <span v-if="uploadType === 'pdf'">PDF</span><span v-else>Image File</span>
                        </span>
                    </span>
                </transition>
            </label>
        </div>
    </ValidationProvider>
</template>

<script>
import axios from 'axios';
import store from '@/store/store';

export default {
    props: {
        namespace: {
            type: String,
            required: true
        },

        uploadType: {
            type: String,
            required: true
        },

        fieldLocation: {
            type: String,
        }
    },

    data() {
        return {
            currentFile: undefined,
            uploadErrors: []
        };
    },

    mounted() {
    },

    methods: {
        selectFile() {
            store.commit(`${this.namespace}/toggleOverlay`, true);
            this.uploadFile()
                .then(uploadedImage => {
                    store.dispatch(`${this.namespace}/getUserMedia`) // Get the right library
                        .then(() => {
                            this.currentFile = undefined;
                            const media = uploadedImage.data.data.media.uploaded;
                            store.dispatch(`${this.namespace}/onThumbnailSelect`, {item: media, namespace: this.namespace})
                                .then(() => {
                                    store.commit(`${this.namespace}/setActiveTab`, 'userMedia'); // Load the right tab
                                    store.commit(`${this.namespace}/toggleOverlay`, false);
                                });
                        });
                })
                .catch(error => {
                    this.handleUploadError(error);
                });
        },

        handleUploadError(error) {
            this.uploadErrors = error.response.data.errors.file;
            store.commit(`${this.namespace}/toggleOverlay`, false);
        },

        uploadFile() {
            this.uploadErrors = [];
            store.commit(`${this.namespace}/toggleOverlay`, true);
            return new Promise((resolve, reject) => {
                let formData = new FormData();
                formData.append('file', this.currentFile);
                formData.append('fieldLocation', this.fieldLocation);

                axios.post('/api/media/create',
                    formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
    }
};
</script>
